import {AuthorizationInfo, extractAuthorizationTierDetail} from "./domain";
import {TextFieldReadonly} from "../../common/component/TextFieldReadonly";
import React from "react";

export type AuthorizationTierDetailSectionProps = {
    authorization: AuthorizationInfo | null;
    tierNum: number;
}

export function AuthorizationTierDetailSection({authorization, tierNum}: AuthorizationTierDetailSectionProps) {
    if (authorization == null) {
        return <div/>;
    }

    const {
        isDraft,
        directCareHour,
        directCareCode,
        groupCareHour,
        groupCareCode,
        midLevelHour,
        midLevelCode,
        highLevelHour,
        highLevelCode,
        startDate,
        endDate,
        directCareBeneficialHour,
        midLevelBeneficialHour,
        highLevelBeneficialHour,
        groupCareBeneficialHour,
        serviceType,
    } = extractAuthorizationTierDetail(authorization, tierNum);
    if (isDraft) {
        return <div/>
    }

    return (
        <div className="p-2 relative w-full">
            <div className="absolute ml-4 top-1 bg-white font-semibold">Tier {tierNum}</div>
            <div className="mt-3 grid grid-cols-2 gap-1 justify-around border-2 w-full p-2">
                <TextFieldReadonly label={"Service Type"}
                                   value={serviceType}
                                   fullRow
                                   labelAtTop
                                   valueOpacity={false}
                                   small/>
                <TextFieldReadonly label={"Start Date"}
                                   value={startDate}
                                   labelAtTop
                                   isDate
                                   valueOpacity={false}
                                   small/>
                <TextFieldReadonly label={"End Date"}
                                   value={endDate}
                                   isDate
                                   labelAtTop
                                   valueOpacity={false}
                                   small/>

                {
                    directCareCode !== "None" &&
                    <>
                        <TextFieldReadonly label={"Paraprofessional Procedure Code"}
                                           value={directCareCode}
                                           fullRow
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Paraprofessional Minimum Hours per month"}
                                           value={directCareBeneficialHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Paraprofessional Maximum Hours per month"}
                                           value={directCareHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                    </>
                }
                {
                    midLevelCode !== "None" &&
                    <>
                        <TextFieldReadonly label={"Mid Level Procedure Code"}
                                           value={midLevelCode}
                                           labelAtTop
                                           fullRow
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Mid-Level Minimum Hours per month"}
                                           value={midLevelBeneficialHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Mid-Level Maximum Hours per month"}
                                           value={midLevelHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                    </>
                }

                {
                    highLevelCode !== "None" &&
                    <>
                        <TextFieldReadonly label={"High-Level Procedure Code"}
                                           value={highLevelCode}
                                           labelAtTop
                                           fullRow
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"High-Level Minimum Hours per month"}
                                           value={highLevelBeneficialHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"High-Level Maximum Hours per month"}
                                           value={highLevelHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                    </>
                }


                {
                    groupCareCode !== "None" &&
                    <>
                        <TextFieldReadonly label={"Group Care Procedure Code"}
                                           value={groupCareCode}
                                           labelAtTop
                                           fullRow
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Group Care Minimum Hours per month"}
                                           value={groupCareBeneficialHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                        <TextFieldReadonly label={"Group Care Maximum Hours per month"}
                                           value={groupCareHour}
                                           labelAtTop
                                           valueOpacity={false}
                                           small/>
                    </>
                }
            </div>
        </div>);
}
